import * as SportType from 'constants/SportType';
import * as ScoreType from 'constants/ScoreType';

const GENERIC_TWO_PERIODS = {
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod
    ]
};
const GENERIC_THREE_PERIODS = {
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod,
        ScoreType.ThirdPeriod
    ]
};
const GENERIC_FOUR_PERIODS = {
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod,
        ScoreType.ThirdPeriod,
        ScoreType.FourthPeriod
    ]
};
const GENERIC_FIVE_PERIODS = {
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod,
        ScoreType.ThirdPeriod,
        ScoreType.FourthPeriod,
        ScoreType.FifthPeriod
    ]
};
const GENERIC_SEVEN_PERIODS = {
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod,
        ScoreType.ThirdPeriod,
        ScoreType.FourthPeriod,
        ScoreType.FifthPeriod,
        ScoreType.SixthPeriod,
        ScoreType.SeventhPeriod
    ]
};
const TENNIS = {
    additional: [
        ScoreType.FirstPeriod,
        ScoreType.SecondPeriod,
        ScoreType.ThirdPeriod,
        ScoreType.FourthPeriod,
        ScoreType.FifthPeriod,
        ScoreType.CurrentGame
    ]
};

const statsPresentation = {};

statsPresentation[SportType.TABLE_TENNIS] = GENERIC_SEVEN_PERIODS;
statsPresentation[SportType.VOLLEYBALL] = GENERIC_FIVE_PERIODS;
statsPresentation[SportType.BEACH_VOLLEYBAL] = GENERIC_THREE_PERIODS;
statsPresentation[SportType.FOOTBALL] = GENERIC_TWO_PERIODS;
statsPresentation[SportType.BEACH_FOOTBALL] = GENERIC_THREE_PERIODS;
statsPresentation[SportType.HANDBALL] = GENERIC_TWO_PERIODS;
statsPresentation[SportType.ICE_HOCKEY] = GENERIC_THREE_PERIODS;
statsPresentation[SportType.BASKETBALL] = GENERIC_FOUR_PERIODS;
statsPresentation[SportType.BADMINTON] = GENERIC_THREE_PERIODS;
statsPresentation[SportType.FUTSAL] = GENERIC_THREE_PERIODS;
statsPresentation[SportType.BASKETBALL_NCAA] = GENERIC_TWO_PERIODS;
statsPresentation[SportType.TENNIS] = TENNIS;

export default class MatchScoresAdapter {
    static getAdditionalScores(sportId, scores) {
        const result = [];

        if (!statsPresentation.hasOwnProperty(sportId)) {
            return result;
        }

        const map = statsPresentation[sportId];

        if (!map.hasOwnProperty('additional')) {
            return result;
        }

        for (let i = 0; i < map.additional.length; i++) {
            let type = map.additional[i];

            const score = scores.getIn([type]);
            if (score && score.get('score1') !== null && score.get('score1') !== undefined &&
                score.get('score2') !== null && score.get('score2') !== undefined) {
                result[i] = score.get('id');
            }
        }

        return result;
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/adapters/MatchScoresAdapter.js